'use strict';
const _ = require('lodash');

module.exports = (input) => {
  if (_.isNil(input) || _.isEmpty(input)) {
    return input;
  }

  const parts = input
    .replace(/\s\s+/g, ' ')
    .replace(/^a-zà-ž'`"’-/, '')
    .split(/\s/);
  return parts
    .map((part) => {
      const matches = part.match(/[a-zà-ž'`"’]+|-/gi);
      if (_.isArray(matches)) {
        return matches
          .map(_.upperFirst)
          .join('');
      }
    })
    .join(' ')
    .trim();
};
